/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPlaidInstitutionsRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/GetPlaidInstitutions.pb'
import {GetPlaidInstitutionsResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/GetPlaidInstitutions.pb'


export const getPlaidInstitutions = (request: GetPlaidInstitutionsRequest, options?: CashRequestOptions) => post<GetPlaidInstitutionsRequest, GetPlaidInstitutionsResponse>("/2.0/cash/get-plaid-institutions", request, {...options, rejectOnError: true })